export default "__VITE_ASSET__57bac59d__"